import { FC } from 'react'
import Text from '../../__legacy__/components/core/Text/Text'
import { RedirectsTableRows } from './components'
import { RedirectTable } from './primitives'

export const Redirects: FC = () => {
  return (
    <RedirectTable.Container>
      <RedirectTable.Header />
      <Text size="14" type="secondary">
        The following routes will redirect from one to another.
      </Text>
      <RedirectTable.InfoDisclaimer />
      <RedirectsTableRows />
    </RedirectTable.Container>
  )
}
